import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@/components/themeProvider";
import { AppStatus } from "@/components/appStatus";
import { AuthProvider } from "@/context/AuthContext";
import { CompanyConfigProvider } from "@/context/CompanyConfigContext";
import { TimeProvider } from "@/context/TimeContext";
import { ToastProvider } from "@/context/ToastContext";
import { RedemptionCodeProvider } from "@/context/RedemptionCodeContext";
import { UrlCodeProvider } from "@/context/UrlCodeContext";
import { FirebaseStorageUrlProvider } from "@/context/FirebaseStorageUrlContext";
import { NavigationHistoryProvider } from "@/context/NavigationHistoryContext";
import { DevFirestoreLogger } from "@/components/DevFirestoreLogger";
import { AppRoutes } from "@/pages/AppRoutes";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { LogRocketProvider } from "@/components/logRocketProvider";
import { ProgramProvider } from "@/context/ProgramContext";

export const App = () => {
  if (process.env.NODE_ENV === "development") {
    if (window.location.pathname === "/dev-tools") {
      return <DevFirestoreLogger />;
    }
  }

  return (
    <div className="responsive-container">
      <ErrorBoundary>
        <BrowserRouter>
          <NavigationHistoryProvider>
            <CompanyConfigProvider>
              <TimeProvider>
                <ThemeProvider>
                  <FirebaseStorageUrlProvider>
                    <ToastProvider>
                      <AppStatus>
                        <AuthProvider>
                          <ProgramProvider>
                            <RedemptionCodeProvider>
                              <UrlCodeProvider>
                                <AppRoutes />
                              </UrlCodeProvider>
                            </RedemptionCodeProvider>
                            <LogRocketProvider />
                          </ProgramProvider>
                        </AuthProvider>
                      </AppStatus>
                    </ToastProvider>
                  </FirebaseStorageUrlProvider>
                </ThemeProvider>
              </TimeProvider>
            </CompanyConfigProvider>
          </NavigationHistoryProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
};
